var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":"xl"}},[_c('h1',[_vm._v("Sign in")]),_c('login-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }